"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var CalendarTheme = function CalendarTheme(colors, breakpoints) {
  return {
    '.react-calendar': {
      width: '350px',
      maxWidth: '100%',
      fontFamily: 'Arial, Helvetica, sans-serif',
      lineHeight: '1.125em',
      background: '#FFFFFF'
    },
    '.react-calendar--doubleView': {
      width: '700px'
    },
    '.react-calendar--doubleView .react-calendar__viewContainer': {
      display: 'flex',
      margin: '-0.5em'
    },
    '.react-calendar--doubleView .react-calendar__viewContainer > *': {
      width: '50%',
      margin: '0.5em'
    },
    '.react-calendar,  .react-calendar *,  .react-calendar *:before,  .react-calendar *:after': {
      MozBoxSizing: 'border-box',
      WebkitBoxSizing: 'border-box',
      boxSizing: 'border-box'
    },
    '.react-calendar button': {
      margin: '0',
      border: '0',
      outline: 'none'
    },
    '.react-calendar button:enabled:hover': {
      cursor: 'pointer'
    },
    '.react-calendar__navigation': {
      display: 'flex',
      height: '44px',
      marginBottom: '1em'
    },
    '.react-calendar__navigation__label__labelText': {
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '115%',
      textAlign: 'center',
      letterSpacing: '0.029em',
      textTransform: 'capitalize'
    },
    '.react-calendar__navigation button': {
      minWidth: '44px',
      background: 'none',
      color: colors.ultramarine
    },
    '.react-calendar__navigation button:disabled': {
      backgroundColor: '#f0f0f0'
    },
    '.react-calendar__navigation button:enabled:not(.react-calendar__tile--hoverEnd):hover,  .react-calendar__navigation button:enabled:not(.react-calendar__tile--hoverEnd):not(.react-calendar__tile--hoverStart):focus': {
      backgroundColor: '#e6e6e6'
    },
    '.react-calendar__month-view__weekdays': {
      textAlign: 'center',
      textTransform: 'capitalize',
      color: colors.ultramarine,
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '120%'
    },
    '.react-calendar__month-view__weekdays__weekday': {
      padding: '0.5em'
    },
    '.react-calendar__month-view__weekNumbers .react-calendar__tile': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.75em',
      fontWeight: 'bold'
    },
    '.react-calendar__month-view__days__day': {
      color: colors.lynch
    },
    '.react-calendar__month-view__days__day--weekend': {
      color: colors.lynch
    },
    '.react-calendar__month-view__days__day--neighboringMonth': {
      color: '#C6C8D0'
    },
    '.react-calendar__year-view .react-calendar__tile,  .react-calendar__decade-view .react-calendar__tile,  .react-calendar__century-view .react-calendar__tile': {
      padding: '1em 1em'
    },
    '.react-calendar__tile': {
      width: '48px',
      height: '48px',
      maxWidth: '100%',
      padding: '10px 6.6667px',
      background: 'none',
      textAlign: 'center',
      lineHeight: '16px',
      fontFamily: 'Barlow',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '14px'
    },
    '.react-calendar__tile:disabled': {
      backgroundColor: '#f0f0f0'
    },
    '.react-calendar__tile:enabled:not(.react-calendar__tile--rangeEnd):not(.react-calendar__tile--hoverStart):not(.react-calendar__tile--hoverEnd):hover,  .react-calendar__tile:enabled:not(.react-calendar__tile--rangeEnd):focus': {
      backgroundColor: colors.bleuDigital05,
      color: colors.hover,
      borderRadius: '24px'
    },
    '.react-calendar__tile--hasActive': {
      background: '#76baff'
    },
    '.react-calendar__tile--hasActive:enabled:hover,  .react-calendar__tile--hasActive:enabled:focus': {
      background: '#a9d4ff'
    },
    '.react-calendar__tile--active': {
      color: 'white',
      background: colors.userBlue
    },
    '.react-calendar__tile--active:enabled:hover,  .react-calendar__tile--active:enabled:focus': {},
    '.react-calendar--selectRange .react-calendar__tile--hover': {
      backgroundColor: colors.userBlue,
      color: '#FFFFFF'
    },
    abbr: {
      textDecoration: 'none'
    },
    '.react-calendar__tile--rangeStart:not(.react-calendar__tile--rangeBothEnds):not(.react-calendar__tile--hoverEnd), .react-calendar__tile--rangeStart:not(.react-calendar__tile--hoverEnd):not(.react-calendar__tile--rangeBothEnds):focus': {
      borderRadius: '24px 0px 0px 24px'
    },
    '.react-calendar__tile--rangeEnd:not(.react-calendar__tile--hoverStart):not(.react-calendar__tile--hoverEnd):not(.react-calendar__tile--rangeBothEnds)': {
      background: colors.userBlue,
      borderRadius: '0px 24px 24px 0px',
      padding: '0px 0px 0px 1px'
    },
    '.react-calendar__month-view__days__day.react-calendar__tile--rangeEnd:not(.react-calendar__tile--rangeBothEnds):before': {
      zIndex: 0,
      content: "''",
      display: 'block',
      width: '48px',
      height: '48px',
      borderRadius: '24px',
      backgroundColor: colors.click
    },
    '.react-calendar__month-view__days__day.react-calendar__tile--rangeEnd:not(.react-calendar__tile--rangeBothEnds) abbr': {
      position: 'relative',
      bottom: '32px',
      zIndex: 1
    },
    '.react-calendar__tile--rangeBothEnds': {
      background: colors.userBlue,
      borderRadius: '24px',
      color: '#FFFFFF'
    },
    '.react-calendar__year-view__months .react-calendar__tile--now': {
      background: colors.click,
      color: '#FFFFFF',
      borderRadius: '24px'
    },
    '.react-calendar__decade-view__years .react-calendar__tile--now': {
      background: colors.click,
      color: '#FFFFFF',
      borderRadius: '24px'
    },
    '.react-calendar__tile--hoverStart:not(.react-calendar__tile--hoverEnd)': {
      borderRadius: '24px 0px 0px 24px'
    },
    '.react-calendar__tile--hoverEnd:not(.react-calendar__tile--hoverStart)': {
      borderRadius: '0px 24px 24px 0px'
    },
    '.react-calendar__tile--hoverStart, .react-calendar__tile--hoverEnd': {
      borderRadius: '24px'
    }
  };
};

var _default = CalendarTheme;
exports["default"] = _default;